/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class TranslationDaoService implements Resetable {
  /**
   * Saves the whole translations object for all availalbe languages to the storage
   * @param translations the translation object coming from remote
   */
  public abstract saveTranslations(translations: Object): Promise<void>;

  /**
   * Gets the whole translations object for all availalbe languages from the storage
   * @return the translation object coming from remote
   */
  public abstract getTranslations(): Promise<Object>;

  // Clearable
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
